// A list row: a glyph, a title over a subtitle, something trailing, a
// chevron. The title is the button and stretches over the whole row, so the
// trailing control stays its own button rather than nesting inside one.
// Long-press and right-click handlers go on the row itself (see Menu).
import type { HTMLAttributes, ReactNode } from 'react';
import { Icon } from './Icon';
import { cx } from './cx';

export interface RowProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  leading?: ReactNode;
  title: string;
  subtitle?: string;
  trailing?: ReactNode;
  chevron?: boolean;
  selected?: boolean;
  onSelect?: () => void;
  /** A button shown under a mouse only; touch has long-press. */
  control?: ReactNode;
}

export function Row({ leading, title, subtitle, trailing, chevron, selected, onSelect, control, className, ...rest }: RowProps) {
  return (
    <div className={cx('row', selected && 'sel', className)} {...rest}>
      {leading && <span className="row-glyph">{leading}</span>}
      <button type="button" className="row-main" onClick={onSelect} aria-current={selected ? 'true' : undefined}>
        <span className="row-title clamp1">{title}</span>
        {subtitle && <span className="row-sub clamp1">{subtitle}</span>}
      </button>
      {trailing && <span className="row-trail">{trailing}</span>}
      {control && <span className="row-control">{control}</span>}
      {chevron && <Icon name="chev" className="row-chev" />}
    </div>
  );
}
